import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Music, ListMusic, LayoutDashboard, Radio } from "lucide-react";

const navItems = [
  { to: "/", label: "Painel", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/songs", label: "Músicas", icon: Music, testid: "nav-songs" },
  { to: "/setlists", label: "Setlists", icon: ListMusic, testid: "nav-setlists" },
];

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#121212] text-white flex flex-col">
      <header className="sticky top-0 z-50 border-b border-[#2D2D2D] bg-[#121212]/95 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <NavLink
            to="/"
            className="flex items-center gap-2.5 group"
            data-testid="brand-logo"
          >
            <div className="w-9 h-9 rounded-md bg-[#00F0FF] flex items-center justify-center text-black">
              <Radio className="w-5 h-5" strokeWidth={2.5} />
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-bold text-base tracking-tight">SetlistPro</span>
              <span className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">
                stage ready
              </span>
            </div>
          </NavLink>

          <nav className="flex items-center gap-1 sm:gap-2">
            {navItems.map(({ to, label, icon: Icon, testid }) => {
              const active =
                to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(to);
              return (
                <NavLink
                  key={to}
                  to={to}
                  data-testid={testid}
                  className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-md text-sm font-medium transition-all duration-150 ${
                    active
                      ? "bg-[#00F0FF] text-black"
                      : "text-zinc-300 hover:text-white hover:bg-[#1A1A1A]"
                  }`}
                >
                  <Icon className="w-4 h-4" strokeWidth={2} />
                  <span className="hidden sm:inline">{label}</span>
                </NavLink>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-[#2D2D2D] py-6 text-center text-xs text-zinc-600 font-mono">
        SETLISTPRO · BUILT FOR THE STAGE
      </footer>
    </div>
  );
}
